// src/features/visitroute/visitrouteSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { VisitrouteSerializer } from "@/types/visitroute"
import { fetchVisitrouts } from "@core/api/visitrouteApi"

interface VisitroutePayload {
  visitroutes: VisitrouteSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: VisitroutePayload = {
  visitroutes: null,
  loading: false,
  error: null,
}

const visitrouteSlice = createSlice({
  name: "visitroute",
  initialState,
  reducers: {
    clearVisitroute(state) {
      state.visitroutes = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchVisitrouts.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchVisitrouts.fulfilled, (state, action) => {
        state.loading = false
        state.visitroutes = action.payload
      })
      .addCase(fetchVisitrouts.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "알 수 없는 오류 발생"
      })
  },
})

export const { clearVisitroute, setLoading, setError } = visitrouteSlice.actions

export default visitrouteSlice.reducer
